<template>
    <div v-if="errorBag.length" class="query-error-container-outer">
        <div class="query-error-container-inner">
            <ul>
                <li v-for="(error, index) in getErrors()" v-bind:key="index">
                    <div :class="['errorContainer row', error.type, errorBag.indexOf(error) === errorBag.length-1 ? 'slidein' : '']"> <!-- TODO: Turn this into a component -->
                        <i class="material-icons col-1">
                            {{ error.type === 'error' ? 'highlight_off' : error.type === 'success' ? 'check_circle_outline' : error.type === 'info' ? 'error_outline' : ''}}
                        </i>
                        <div :id="errorBag.indexOf(error)" class="error-text col" v-html="error.message"></div> <!-- v-html outputs raw HTML -->
                        <span class="closeButton col-1" v-on:click="deleteError(errorBag.indexOf(error))">&times;</span>
                    </div>
                </li>
            </ul>
        </div>
        <!--<button v-on:click="addError('Error: ' + Math.random())">Add error</button>-->
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import { eventBus } from '../main';

export default {
    name: 'queryErrorContainer',
    mixins: [
        Default
    ],
    data() {
        return {
            errorBag: [],
            container: null,
            timeToLive: 10 * 1000, // Milliseconds before error disappears,
            timeouts: []
        };
    },
    created: function() {
        eventBus.$on('addError', this.addError);
        eventBus.$on('getErrors', function(callback) {
            callback(this.getErrors());
        }.bind(this));
        eventBus.$on('clearErrors', this.clearErrors);

        this.checkErrors();
    },
    watch: {
        queryErrors: function(newVal, oldVal) {
            this.checkErrors();
        }
    },
    methods: {
        checkErrors: function() {
            if (this.queryErrors) {
                if (this.queryErrors instanceof Array && this.queryErrors.filter(error => { return error === 'login-error'; }).length > 0)
                    this.addError('You must be logged in to do that');
                if (this.queryErrors instanceof Array && this.queryErrors.filter(error => { return error === 'identification-error'; }).length > 0)
                    this.addError('You do not have access to that account');
            }
        },
        clearErrors: async function() {
            this.errorBag = [];
            await this.$store.dispatch(this.$store.types.path.actions.clearErrors);
            this.timeouts.forEach((id) => {
                clearTimeout(id);
            });
        },
        deleteError: function(index) {
            this.errorBag.splice(index, 1);
        },
        getErrors: function() {
            return this.errorBag.slice().reverse();
        },
        addError: function(msg, type = this.$parleyAdmin.queryErrors.TYPE_ERROR) {
            if (Object.values(this.$parleyAdmin.queryErrors).indexOf(type) === -1)
                throw new Error(`Invalid type '${type}' for query error`);

            const error = {message: msg, type: type, time: this.getCurrentTimeFormatted()};
            this.errorBag.push(error);
            if (this.errorBag.length > 1) // Skip the first error because this.container is still null
                if (this.isContainerOverflown())
                    this.deleteError(0);
            this.resetAnimation();

            // Delete error after X ms
            if (type !== this.$parleyAdmin.queryErrors.TYPE_ERROR) {
                const id = setTimeout(() => {
                    const index = this.errorBag.indexOf(error);
                    this.errorBag.splice(index, 1);
                }, this.timeToLive);
                this.timeouts.push(id);
            }
        },
        isContainerOverflown: function() {
            if (!this.container)
                this.container = document.querySelectorAll('div.query-error-container-inner')[0];
            return this.container.scrollHeight > this.container.clientHeight;
        },
        resetAnimation: function() {
            const newErrorNode = document.getElementsByClassName('slidein')[0];

            if (!newErrorNode)
                return;

            newErrorNode.classList.remove('slidein');
            void newErrorNode.offsetWidth; // Hack that forces a reflow (so the animation 'slidein' restarts
            newErrorNode.classList.add('slidein');
        },
        getCurrentTimeFormatted: function() {
            const d = new Date();
            const h = (d.getHours() < 10 ? '0' : '') + d.getHours();
            const m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
            const s = (d.getSeconds() < 10 ? '0' : '') + d.getSeconds();
            return h + ':' + m + ':' + s;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    ul {
        list-style-type: none;
    }
    .query-error-container-outer {
        position: absolute;
        right: 0;
        z-index: 99;
        margin: 1em 1.25em;
    }
    .query-error-container-inner {
        position: relative;
        max-height: calc(100vh - 45px);
        overflow: hidden;

        .errorContainer {
            overflow: auto;
            padding: 1em;
            margin-bottom: 10px;
            border-radius: 6px;
            max-width: 400px;
            position: relative;
            background: white no-repeat 10px center;
            font-weight: 400;

            // Reset some bootstrap column stuff
            .col-1,
            .col {
                padding: unset;
                width: auto;
            }

            .material-icons {
                margin-right: .5em;
            }

            .error-text {
                margin-right: 1em;
                white-space: pre-line;
            }

            ul {
                list-style-type: none;
                margin: 0;
                padding-left: 0;
            }
            &.error {
                border: 1px #f5222d solid;

                .material-icons {
                    color: #f5222d;
                }

                .closeButton {
                    color: #f5222d;
                }
            }
            &.info {
                border: 1px #1890ff solid;

                .material-icons {
                    color: #1890ff;
                }

                .closeButton {
                    color: #1890ff;
                }
            }
            &.success {
                border: 1px #52c41a solid;

                .material-icons {
                    color: #52c41a;
                }

                .closeButton {
                    color: #52c41a;
                }
            }

            &.slidein {
                animation-duration: 1s;
                animation-name: slidein;
            }

            .time {
                font-size: 10px;
                bottom: 5px;
                position: absolute;
                right: 10px;
            }

            .closeButton {
                /*float: right;*/
                font-size: 2em;
                /*font-weight: bold;*/
                line-height: 0.5;
                color: #000;
                filter: alpha(opacity=20);
                /*opacity: .2;*/
                cursor: pointer;

                position: absolute;
                top: 0;
                right: 0;
                margin: .25em;
            }
        }
    }

    @keyframes slidein {
        from {
            margin-left: 100%;
            width: 100%;
            opacity: 0;
        }
        to {
            margin-left: 0%;
            width: 100%;
            opacity: 1;
        }
    }
</style>
